import classNames from "classnames";
import {
  goToDesign,
  goToQuantity,
  goToReview,
} from "../../../designer/store/slices/stepSlice";
import { useAppDispatch, useAppSelector } from "../../../hooks/reduxHooks";

const Steps = () => {
  const currentStep = useAppSelector((state) => state.steps.step);
  const dispatch = useAppDispatch();

  return (
    <div className="flex uppercase text-sm h-full hidden xl:flex">
      <div
        onClick={() => dispatch(goToDesign())}
        className={classNames(
          "mr-6 cursor-pointer flex h-full items-center border-y-[3px] border-solid",
          {
            ["border-transparent"]: currentStep !== 0,
            ["text-primaryred border-b-primaryred border-t-transparent"]:
              currentStep === 0,
          }
        )}
      >
        <span
          className={classNames(
            "inline-block w-[20px] h-[20px] text-center text-white text-xs rounded-full pt-[1px] mr-1",
            {
              ["bg-primaryred"]: currentStep === 0,
              ["bg-darkgrey"]: currentStep !== 0,
            }
          )}
        >
          1
        </span>{" "}
        Design
      </div>
      <div
        onClick={() => dispatch(goToQuantity())}
        className={classNames(
          "mr-6 cursor-pointer flex h-full items-center border-y-[3px] border-solid",
          {
            ["border-transparent"]: currentStep !== 1,
            ["text-primaryred border-b-primaryred border-t-transparent"]:
              currentStep === 1,
          }
        )}
      >
        <span
          className={classNames(
            "inline-block w-[20px] h-[20px] text-center text-white text-xs rounded-full pt-[1px] mr-1",
            {
              ["bg-primaryred"]: currentStep === 1,
              ["bg-darkgrey"]: currentStep !== 1,
            }
          )}
        >
          2
        </span>{" "}
        Quantity & Sizes
      </div>
      <div
        onClick={
          currentStep === 0 || currentStep === 1
            ? undefined
            : () => dispatch(goToReview())
        }
        className={classNames(
          "mr-6 flex h-full items-center border-y-[3px] border-solid",
          {
            // Grey out and disable pointer events when currentStep is 0.
            "opacity-50 pointer-events-none cursor-not-allowed":
              currentStep === 0 || currentStep === 1,
            // Otherwise, show a pointer cursor.
            "cursor-pointer": currentStep !== 0,
            // Styling for step 2.
            "border-transparent": currentStep !== 2,
            "text-primaryred border-b-primaryred border-t-transparent":
              currentStep === 2,
          }
        )}
      >
        <span
          className={classNames(
            "inline-block w-[20px] h-[20px] text-center text-white text-xs rounded-full pt-[1px] mr-1",
            {
              "bg-primaryred": currentStep === 2,
              "bg-darkgrey": currentStep !== 2,
            }
          )}
        >
          3
        </span>
        Review Price
      </div>
    </div>
  );
};
export default Steps;
